import React from "react";
import "../../../../css/Common/Components/Cards/CardMetric.css";
import "../../../../css/App.css";

/**
 * CardMetric is a React component that displays a metric card with content and a value.
 * The card visually toggles a "clicked" state when clicked.
 *
 * Props:
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.content - The content to display inside the card.
 * @param {string|number} props.value - The value to display as the metric.
 *
 * State:
 * @property {boolean} clicked - Indicates whether the card has been clicked.
 * @property {boolean} greenClicked - (Unused) Reserved for future use.
 *
 * Example usage:
 * <CardMetric content="Total Users" value={100} />
 */
class CardMetric extends React.Component {
  constructor() {
    super();

    this.state = {
      clicked: false,
      greenClicked: false,
    };
  }

  render() {
    const { content, value } = this.props;
    return (
      <>
        <div
          className={`Card-Metric ${this.state.clicked ? "clicked" : ""}`}
          onClick={() => this.setState({ clicked: !this.state.clicked })}
        >
          <div className="Content">{content}</div>
          <h3>{value}</h3>
        </div>
      </>
    );
  }
}

export default CardMetric;
